// 检测是否在 Tauri 环境中
export const isTauri = () => {
  return typeof window !== 'undefined' && '__TAURI_INTERNALS__' in window;
};

// 安全的 invoke 包装器
export const safeInvoke = async <T = any>(
  cmd: string,
  args?: Record<string, unknown>
): Promise<T | null> => {
  if (!isTauri()) {
    console.warn(`[Browser] invoke('${cmd}') - 在浏览器中不可用`);
    return null;
  }
  
  const { invoke } = await import('@tauri-apps/api/core');
  try {
    return await invoke<T>(cmd, args);
  } catch (error) {
    console.error(`invoke('${cmd}') 失败:`, error);
    return null;
  }
};

